import React from 'react';
import { NavLink } from 'react-router-dom';
const Uganda1_advanced_secondary_subjects = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Agriculture</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Arabic</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Biology</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Chemistry</NavLink> 
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Chinese</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Christian Religious Education</NavLink>

      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >English</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Entrepreneurship</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Fine Arts</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >French</NavLink> 
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >General Science</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Geography</NavLink>

      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >German</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >History and Political Education</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Information Communication and Technology</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Islamic Religious Education</NavLink> 
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Kiswahili</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Latin</NavLink>

      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Literature in English</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      ></NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Luganda</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Lusoga</NavLink> 
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      ></NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Mathematics</NavLink>

      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Nutrition and Food Technology</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Physical Education</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Performing Arts</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Physics</NavLink> 
        <NavLink to="/tutoring/learner/uganda1/uganda1_advanced_secondary/uganda1_advanced_secondary_agr" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' 
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' 
        }
      >Technology and Design</NavLink>
                
    </div>
  );
}

export default Uganda1_advanced_secondary_subjects;
